import React from "react";

const notifications : any[] = [];

export const UserContext = React.createContext({
    userId: "-1",
    notifications: notifications,
    addNotification: (notification : any) : void => {
        // eslint-disable-next-line no-console
        console.log(notification);
    },
    shownNotification: (notification : any) : void => {
        // eslint-disable-next-line no-console
        console.log(notification);
    },
});
